/* src/app/time-check/time-check.component.scss */
/*# sourceMappingURL=/time-check.component.css.map */
